import { createPortal } from 'react-dom'
import { Toaster } from 'sonner'

const iconProps = {
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2.4,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const

const Check = () => (
  <svg {...iconProps} aria-hidden="true">
    <path d="M3.6 8.3 6.6 11.3 12.4 4.7" />
  </svg>
)

const Cross = () => (
  <svg {...iconProps} aria-hidden="true">
    <path d="M4.6 4.6 11.4 11.4M11.4 4.6 4.6 11.4" />
  </svg>
)

const Info = () => (
  <svg {...iconProps} aria-hidden="true">
    <path d="M8 7.4v4.2" />
    <path d="M8 4.4v.2" />
  </svg>
)

const Warning = () => (
  <svg {...iconProps} aria-hidden="true">
    <path d="M8 4.4v4.8" />
    <path d="M8 11.4v.2" />
  </svg>
)

/**
 * Application toasts.
 *
 * Portalled to `<body>` deliberately. `#app` sets `position: relative;
 * z-index: 2`, which makes it a stacking context — a toaster left inside it can
 * never rise above an overlay that portalled out to `<body>`, whatever
 * z-index it carries. A confirmation painted behind the modal that triggered
 * it, dimmed by that modal's backdrop, reads as nothing having happened.
 *
 * Bottom-centre rather than the top-right corner: it is where the eye already
 * is after pressing a button near the middle of the page, and it does not
 * collide with the toolbar's account menu.
 */
export function Toasts() {
  return createPortal(
    <Toaster
      position="bottom-center"
      duration={3600}
      gap={10}
      visibleToasts={3}
      // Listed one above the other, as in litty-app, rather than collapsed
      // into a pile where only the newest can be read.
      expand
      icons={{
        success: <Check />,
        error: <Cross />,
        info: <Info />,
        warning: <Warning />,
      }}
    />,
    document.body,
  )
}
